const cards = [
  { id: 1, eng: "Hello", vn: "Xin chào" },
  { id: 2, eng: "How are you", vn: "Bạn khoẻ không?" },
  { id: 3, eng: "I'm good", vn: "Mình khoẻ" },
  { id: 4, eng: "Thank you", vn: "Cảm ơn" },
  { id: 5, eng: "See you again", vn: "Hẹn gặp lại" },
]

export default cards
